import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CashbackAccount, CompanyDetailsInterface, Franchise } from '../../services/exports/Interfaces';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { InitialDataStoreInterface, StoreInterface } from '../types';
import { SliceCaseReducers } from '@reduxjs/toolkit/dist/createSlice';

interface SliceState {
  franchise?: Franchise;
  company?: CompanyDetailsInterface;
  cashback_account?: CashbackAccount;
  loading: boolean;
}

export default createSlice<SliceState, SliceCaseReducers<SliceState>>({
  name: REDUX_STORE_SLICES.INITIAL_DATA,
  initialState: {
    franchise: null,
    company: null,
    cashback_account: null,
    loading: false,
  },
  reducers: {
    setAllData: (state, action) => {
      const { franchise, company, cashback_account } = action.payload;

      state.franchise = franchise;
      state.company = company;
      state.cashback_account = cashback_account;
    },
    setFranchise: (state: InitialDataStoreInterface, action: PayloadAction<Franchise>) => {
      state.franchise = action.payload;
    },
    setCompany: (state: InitialDataStoreInterface, action: PayloadAction<CompanyDetailsInterface>) => {
      state.company = action.payload;
    },
    updateCompany: (state: InitialDataStoreInterface, action: PayloadAction<Partial<CompanyDetailsInterface>>) => {
      state.company = {
        ...state.company,
        ...action.payload,
      };
    },
    setCashbackAccount: (state: InitialDataStoreInterface, action: PayloadAction<CashbackAccount>) => {
      state.cashback_account = action.payload;
    },
    toggleLoading: (state, action: PayloadAction<boolean | undefined>) => {
      state.loading = action.payload !== undefined ? action.payload : !state.loading;
    },
    reset: (state) => {
      state.cashback_account = null;
    },
  },
});

export const props = (state: InitialDataStoreInterface) => state;
export const selectCompanyId = (state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].company?.id;
export const selectFranchiseId = (state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].franchise?.id;
export const selectWorkSchedule = (store: StoreInterface) =>
  store[REDUX_STORE_SLICES.INITIAL_DATA].company?.work_schedule;
export const selectCompany = (state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].company;
export const selectFranchise = (state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].franchise;
export const selectCompanyOffers = (state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].company?.offers;
